import { render } from "./Backdrop.vue?vue&type=template&id=47df1dcd&scoped=true"
import script from "./Backdrop.vue?vue&type=script&lang=js"
export * from "./Backdrop.vue?vue&type=script&lang=js"

import "./Backdrop.vue?vue&type=style&index=0&id=47df1dcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47df1dcd"]])

export default __exports__